import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { InactivityActions } from "../../redux/features/inactivitySlice";
import { RootState } from "../../redux/store";
import { Modal } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const ModalContent = styled.div`
  padding: 2em;
`;

const InactivityLogoutTimer = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const inactivityState = useSelector((state: RootState) => state.inactivity);

  const checkForInactivity = () => {
    const expireTimeString = localStorage.getItem("expireTime");
    const expireTime = expireTimeString ? parseInt(expireTimeString) : 0;

    if (expireTime < Date.now()) {
      dispatch(InactivityActions.showAlert());
    }
  };

  const updateExpiryTime = () => {
    const expireTime = Date.now() + 1 * 60 * 60 * 1000; // 1 hour in milliseconds

    localStorage.setItem("expireTime", expireTime.toString());
  };

  useEffect(() => {
    updateExpiryTime();

    const interval = setInterval(() => {
      checkForInactivity();
    }, 10000); // Check for inactivity every 10 seconds

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const events = ["click"]; //, "keypress", "scroll", "mousemove"];

    const update = () => {
      updateExpiryTime();
    };

    events.forEach((event) => window.addEventListener(event, update));

    return () => {
      events.forEach((event) => window.removeEventListener(event, update));
    };
  }, []);

  return (
    <>
      {inactivityState.open === true && (
        <Modal
          closable={false}
          maskClosable={false}
          keyboard={false}
          open={true}
          onCancel={() => dispatch(InactivityActions.hideAlert())}
          footer={null}
        >
          <ModalContent>
            {t("MESSAGES.session-expired")}
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default InactivityLogoutTimer;
